import { render, staticRenderFns } from "./editImagen.vue?vue&type=template&id=214f437c"
import script from "./editImagen.vue?vue&type=script&lang=js"
export * from "./editImagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports